var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortoneDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 264,
    height: 68,
    viewBox: "0 0 264 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Light_Logo_264_X_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 68
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Light_Logo_264_X_68",
    "data-name": "Light Logo \\u2013 264 X 68",
    clipPath: "url(#clip-Light_Logo_264_X_68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86070",
    "data-name": "Group 86070",
    transform: "translate(-3358 -2378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M151.687,38.086V30.268h-6.26s0,7.818,0,7.818c-1.009.013-5.3,0-5.78,0-12.3,0-16.2,4.648-16.234,5.084.008-.087-.013-3.494-.013-5.081h-6.219V69.533H123.4l.006-19.571c.075-3.227,2.654-5.463,5.464-6.125a23.477,23.477,0,0,1,5.226-.659c4.258-.005,7.069-.008,11.326-.01V57.2c0,4.091-.136,8.767,3.976,11.042a11.922,11.922,0,0,0,5.336,1.213c.4.018,6.886.108,6.886.072v-.01l6.083.01V64.4c-4.3,0-7.384.264-11.673-.036a4.724,4.724,0,0,1-3.383-1.454c-1.289-1.567-.968-4.1-.968-5.984V43.167h15.5l6.483-5.084H151.682Z",
    transform: "translate(3322.444 2364.288)",
    fill: "#fefbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M79.021,40.692H77.566c-9.84,0-17.668,7.572-17.668,16.278s6.989,16.278,17.668,16.278h1.455c11.257,0,17.668-7.572,17.668-16.278S88.933,40.692,79.021,40.692ZM90.465,56.97c0,5.91-4.243,11.232-11.691,11.232h-.962A11.272,11.272,0,0,1,66.121,56.97,11.626,11.626,0,0,1,77.812,45.738h.962A11.6,11.6,0,0,1,90.465,56.97Z",
    transform: "translate(3339.825 2361.125)",
    fill: "#fefbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M41.607,35.047c-.649-5.6-3.683-9.039-8.988-10.855a22.787,22.787,0,0,0-7.371-1.167H0V67.371H6.137V50.55H7.315c5.464,0,10.931.087,16.4.051a48.064,48.064,0,0,0,5.043-.3,17.073,17.073,0,0,0,6.524-2.052c4.676-2.629,7-7.408,6.329-13.2ZM30.173,44.83A16.051,16.051,0,0,1,25.3,45.5c-5.952.1-12.315.041-18.269.039-.254,0-.508-.039-.814-.064V28.091h.893c5.983,0,12.374-.069,18.356.044a15.181,15.181,0,0,1,4.936.972c3.339,1.244,5.126,4.007,5.087,7.79-.039,3.8-1.938,6.785-5.323,7.931Z",
    transform: "translate(3358 2366.485)",
    fill: "#fefbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M307.514,48.057a11.415,11.415,0,0,0-4.473-4.666,14.1,14.1,0,0,0-6.842-1.734c-6.3,0-8.835,2.955-9.8,4.627V41.657h-6.224V72.976H286.4V55.267c0-4.042,3.178-8.731,7.9-8.731a8.467,8.467,0,0,1,6.417,2.478q2.167,2.478,2.168,7.064v16.9h6.225V55.118a14.924,14.924,0,0,0-1.592-7.064Z",
    transform: "translate(3272.987 2360.832)",
    fill: "#fefbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M229.163,22.292h-2.01c-13.59,0-24.4,10.44-24.4,22.685s9.656,22.685,24.4,22.685h2.01c15.549,0,24.4-10.44,24.4-22.685S242.856,22.292,229.163,22.292Zm-.672,40.327h-.662c-11.136,0-18.854-8.208-18.854-17.665s8.593-17.665,18.854-17.665h.662c10.339,0,18.854,8.208,18.854,17.665S240.23,62.619,228.49,62.619Z",
    transform: "translate(3296.48 2366.708)",
    fill: "#fefbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M353.882,64.595a11.59,11.59,0,0,1-8.826,3.606h-.963a11.316,11.316,0,0,1-11.388-8.654h30.073a17.178,17.178,0,0,0,.2-2.58c0-8.7-7.756-16.278-17.669-16.278H343.85c-9.84,0-17.669,7.572-17.669,16.278s6.989,16.278,17.669,16.278H345.3c7.741,0,13.192-3.581,15.841-8.649h-7.263Zm-9.789-18.861h.963A11.732,11.732,0,0,1,356.443,54.5H332.708A11.775,11.775,0,0,1,344.093,45.734Z",
    transform: "translate(3259.027 2361.126)",
    fill: "#fefbfb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortoneDark);
export default __webpack_public_path__ + "static/media/portone_dark.2f80a4d54b56d2d8dd8dd7302ca4ab0b.svg";
export { ForwardRef as ReactComponent };